'use strict';

import React, { Component } from 'react'

import SortIcon from '@/Icons/Sort'

export default class DataHeader extends Component
{
	render ()
	{
		var component = this, props = this.props;
		var header_elements = [], i = 0;

		var data = props.data || Object.keys(props.displayed_fields);

		data.forEach(function (element, index)
		{
			let fieldname = (props.header_map || { })[element];

			const is__sortable = props.onSort && (props.sortable_cols || [])
			.includes(fieldname);

			let class_name = 'o-grid__item c-data-row__item';

			class_name += is__sortable ? ' sortable' : '';

			if (props.displayed_fields[element])
			{
				if (is__sortable)
				{
					const onSort = is__sortable
					? (e) => props.onSort({ fieldname: fieldname })
					: undefined;

					let sort_class = 'c-data-row__item-sort';

					if (props.sort_field === fieldname)
					{
						sort_class += ' active';

						sort_class += props.sort_order === 'DESC'
						? ' desc'
						: ' asc';
					}

					const title = is__sortable === false ? undefined :
					(
						props.sort_field === fieldname ? 'inverser' : 'trier'
					);

					header_elements.push
					(
						<li className={ class_name } key={ i++ }>
							<button className={ sort_class } onClick={ onSort }
								title={ title }>
								{ element }
								<SortIcon
									className="c-data-row__item-sort-icon"
								/>
								<div className="c-data-row__item-sort-arrow" />
							</button>
						</li>
					);
				}
				else
				{
					header_elements.push
					(
						<li className={ class_name } key={ i++ }>
							{ element }
						</li>
					);
				}
			}
			else if (props.displayed_fields[element] === false)
			{
				header_elements.push
				(
					<li className="o-grid__item c-data-row__item" key={ i++ }></li>
				);
			}
		});

		let component_class = "c-data-row c-data-row--header"

		if (props.version)
		{
			component_class += ' c-data-row--v' + String(props.version);
		}

		var output =
		(
			<ul className={ component_class }>
				{ header_elements }
			</ul>
		);

		return output;
	}
}
